export default "__VITE_ASSET__hgjNqJuh__"